import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { EmployeeService } from '../employee.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfigService } from '../../../../../core/services/config.service';

@Component({
  selector: 'itpx-employee-edit',
  templateUrl: './employee-edit.component.html',
  styleUrls: ['./employee-edit.component.css']
})
export class EmployeeEditComponent implements OnInit {

    private details: any;
    private sub: Subscription;
    private saveUrl: string;
    private cancelRoute: string = '/agora/account-data/employees';
    private fields: any[];
    private id: string;
    private isInProgress: boolean = false;

    constructor(
            private employeeService: EmployeeService,
            private configService: ConfigService,
            private notificationService: NotificationService,
            private router: Router,
            private route: ActivatedRoute
    ) { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/edit/employee-edit.component.ts